import React from 'react';
import CaseGenerator from "../../CaseGenerator/CaseGenerator";
import {CaseForms} from "../../../helpers/enums";
import './AggiornaDati.css';

const AggiornaDatiCase = () => (
  <div className="AggiornaDatiCase" data-testid="AggiornaDatiCase">
    <CaseGenerator type={CaseForms.AggiornaDati}/>
  </div>
);


export default AggiornaDatiCase;
